// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__qipFo","name":"footer_name__h6nTw","link":"footer_link__j14+d"};